"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.general.title': 'General Settings',
    'settings.general.description': 'Configure your application settings and integrations',
    'settings.general.tabs.googleDrive': 'Google Drive',
    'settings.general.tabs.general': 'General',
    'settings.general.tabs.apiKeys': 'API Keys',
    'settings.general.tabs.rag': 'RAG Settings',
    'settings.general.tabs.credit': 'Credit Settings',
    'settings.general.tabs.socialMedia': 'Social Media',
    'settings.general.generalSettings.comingSoon': 'General settings will be available soon.',
    'settings.general.apiKeys.comingSoon': 'API key management will be available soon.',
    'settings.general.chatLearning.title': 'Chat Learning Summary',
    'settings.general.chatLearning.description': 'Manage your personalized AI learning summary. This information helps the AI provide better, more tailored responses.',
    'settings.general.chatLearning.summaryLabel': 'Learning Summary',
    'settings.general.chatLearning.summaryPlaceholder': 'Enter or edit information about your preferences, context, and important details that should help the AI assist you better...',
    'settings.general.chatLearning.summaryHelp': 'This summary is automatically updated based on your conversations. You can manually edit it to include specific preferences or context.',
    'settings.general.save': 'Save Settings',
    'settings.general.reload': 'Reload',
    'settings.general.savedSuccessfully': 'General settings saved successfully',
    'settings.general.failedToSave': 'Failed to save general settings',
    'settings.general.failedToLoad': 'Failed to load general settings',
    'settings.general.googleDrive.disconnectSuccess': 'Google Drive disconnected successfully',
    'settings.general.googleDrive.disconnectError': 'Failed to disconnect Google Drive',
};
